import Anchor from "./Anchor";
import type { AnchorProps } from "./Anchor.d";

export default Anchor;
export type { AnchorProps };
